import { useCallback, useEffect, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import React from 'react';
import moment from 'moment';
import { utils, writeFile } from 'xlsx';
import { Select, DatePicker } from 'antd';
import {
 Chart as ChartJS,
 CategoryScale,
 LinearScale,
 PointElement,
 LineElement,
 Title,
 Tooltip,
 Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { ContentWrapper } from '../../_common';
import srv from '../../../services';
import SelectContract from '../../_common/SelectContract';
import SelectConnection from '../../_common/SelectConnection';
import {
 SelectBlock,
 Spinner,
 SelectTypeDevice,
 SubmitButton,
} from '../MeteringDevices.styled';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import MeteringHistoryData from './MeteringHistoryData';

const { RangePicker } = DatePicker;

ChartJS.register(
 CategoryScale,
 LinearScale,
 PointElement,
 LineElement,
 Title,
 Tooltip,
 Legend,
);

// 3. Компонент графика
const ExpenseChart = ({ months, values }) => {
 const data = {
  labels: months,
  datasets: [
   {
    label: ' Расход',
    data: values,
    borderColor: '#ffc000',
    backgroundColor: '#ffc000',
    tension: 0.3,
    borderWidth: 3,
   },
  ],
 };

 const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
   legend: {
    display: false,
   },
  },
  scales: {
   x: {
    title: {
     display: true,
     text: '',
     color: '#666',
     font: {
      size: 14,
      weight: 'bold',
      family: 'sans-serif',
     },
     padding: { top: 10, bottom: 0 },
    },
    grid: {
     display: false,
    },
   },
   y: {
    title: {
     display: true,
     text: 'Расход, КВтч',
     color: '#666',
     font: {
      size: 14,
      weight: 'bold',
      family: 'sans-serif',
     },
     padding: { top: 0, bottom: 10 },
    },
    min: 0,
   },
  },
 };

 return (
  <div
   style={{
    width: '100%',
    height: '100%',
    minHeight: '300px',
    padding: '10px',
   }}
  >
   <h3
    style={{
     textAlign: 'center',
     fontFamily: 'sans-serif',
     color: '#333',
     margin: '0 0 10px 0',
     fontSize: '16px',
    }}
   >
    Мониторинг расходов
   </h3>
   <div style={{ height: 'calc(100% - 30px)' }}>
    <Line data={data} options={options} />
   </div>
  </div>
 );
};

export default function MeteringHistory() {
 const {
  changeContract,
  changeConnection,
  changeTypeDevice,
  handleDateRangeValues,
  dateFrom,
  dateTo,
  defaultDateRange,
  typeDevice,
  contractNumber,
  meteringDevice,
  meterings,
  connections,
  contracts,
  onFinish,
  onFinishAskue,
  isLoading,
  accruals,
  accrualsAskue,
  contractData,
  isElectricity,
 } = useAccruals();

 const [askueValue, setAskueValue] = useState<boolean>(false);
 const [mainGrid, setMainGrid] = useState([]);
 const [secondGrid, setSecondGrid] = useState([]);
 const [meterData, setMeterData] = useState<any>();

 const processMeterData = (dataArray) => {
  if (!dataArray || !Array.isArray(dataArray) || dataArray.length === 0) {
   return { months: [], values: [] };
  }

  const momentDates = dataArray
   .filter((item) => item.dataValue)
   .map((item) => moment(item.dataValue));

  const monthsList = [];

  if (momentDates.length > 0) {
   const start = moment.min(momentDates).clone().startOf('month');
   const end = moment.max(momentDates).clone().startOf('month');

   while (start.isSameOrBefore(end)) {
    const label = start.format('MMMM YYYY');
    monthsList.push(label.charAt(0).toUpperCase() + label.slice(1));
    start.add(1, 'month');
   }
  }

  const valuesList = dataArray
   .filter((item) => Array.isArray(item.values))
   .flatMap((item) => item.values.map((v) => v.consumption))
   .toReversed(); // Создает развернутую копию массива

  const obj = {
   months: monthsList,
   values: valuesList,
  };

  setMeterData(obj);
 };

 useEffect(() => {
  setAskueValue(false);
 }, [contracts, connections, meterings]);

 useEffect(() => {
  if (meterings && meterings.length > 0) {
   const data = meterings.filter(
    (x) => x.meteringDeviceId === typeDevice,
   ) as any;

   if (data && data.length > 0) {
    setAskueValue(data[0].askue);
   }

   processMeterData(accruals);

   /**
    * convert data to excell
    */
   const JsonData = accruals;

   if (JsonData && JsonData.values) {
    const inputData = JsonData;
    const uniqueDates = Array.from(
     new Set(inputData.map((item) => item.dataValue)),
    );
    interface readyObject {
     period: string;
     date: string;
     amount: string;
    }

    let readyArray: readyObject[] = [];

    if (uniqueDates && uniqueDates.length > 0) {
     uniqueDates.map((element: any) => {
      const foundRecord = inputData.filter((x) => x.dataValue === element);

      if (foundRecord && foundRecord.length > 0 && foundRecord[0].values) {
       const sum = foundRecord[0].values.reduce(
        (a, v) => (a = a + Number(v.value)),
        0,
       );

       const correctDate = moment(element);
       const period = moment(correctDate).format('MMMM, YYYY');

       const data: readyObject = {
        period: period,
        date: moment(correctDate).format('DD.MM.YYYY HH:MM:ss'),
        amount: sum,
       };

       readyArray.push(data);
      }
     });
     setMainGrid(readyArray);
     setSecondGrid(accrualsAskue?.values ?? []);
    }
   }
  }
 }, [accruals, accrualsAskue]);

 const exportData = () => {
  const customHeaderSheet1 = [
   'Период',
   'Дата и время',
   'Суммарная активная энергия, КВтч',
  ];

  const customHeaderSheet2 = [
   'Дата',
   'Время (час)',
   'Активная энергия (прием)',
  ];

  const ws1Input = utils.json_to_sheet(mainGrid, {
   header: ['period', 'date', 'amount'],
  });
  const ws2Input = utils.json_to_sheet(secondGrid, {
   header: ['date', 'time', 'value'],
  });

  ws1Input['A1'].v = customHeaderSheet1[0];
  ws1Input['B1'].v = customHeaderSheet1[1];
  ws1Input['C1'].v = customHeaderSheet1[2];

  ws2Input['A1'].v = customHeaderSheet2[0];
  ws2Input['B1'].v = customHeaderSheet2[1];
  ws2Input['C1'].v = customHeaderSheet2[2];

  let wb = utils.book_new(),
   ws1 = ws1Input,
   ws2 = ws2Input;
  utils.book_append_sheet(wb, ws1, 'Расход суточный без КТ,КН');
  utils.book_append_sheet(wb, ws2, 'Расход почасовой без КТ,КН');
  writeFile(wb, 'Список показаний.xlsx');
 };

 const exportToPdf = async () => {
  const ITEMS_PER_FIRST_PAGE = 13;
  const ITEMS_PER_NEXT_PAGES = 16;

  const pdf = new jsPDF({
   orientation: 'landscape',
   unit: 'mm',
   format: 'a4',
  });

  const pdfWidth = pdf.internal.pageSize.getWidth();
  const imgWidth = pdfWidth - 30;

  const generateRowsHtml = (items: any[]) => {
   return items
    .map((record: any) => {
     const formattedDate = moment(record.dataValue).format('DD.MM.YYYY') || '-';
     const valuesCount = record?.values?.length || 0;

     // ЕСЛИ В МАССИВЕ ДВА ТАРИФА (ДЕНЬ / НОЧЬ)
     if (valuesCount >= 2) {
      const dayTariff = record.values[0];
      const nightTariff = record.values[1];
      const source =
       dayTariff?.sourceValue || record?.values?.[0]?.sourceValue || '-';

      return `
        <tr style="border-bottom: none;">
          <td style="padding: 2px 10px; color: #000000; font-size: 12px; white-space: nowrap; border-bottom: none;">${formattedDate}</td>
          <td style="padding: 2px 10px; color: #000000; font-size: 12px; white-space: nowrap;">${dayTariff?.name || 'День'}</td>
          <td style="padding: 2px 10px; color: #000000; font-size: 12px; white-space: nowrap; text-align: right;">${dayTariff?.value || '-'}</td>
          <td style="padding: 2px 10px; color: #000000; font-size: 12px; white-space: nowrap; text-align: right;">${dayTariff?.consumption || '-'}</td>
          <td style="padding: 2px 10px 2px 40px; color: #000000; font-size: 12px; white-space: nowrap;">${source}</td>
        </tr>
        <tr style="border-bottom: 1px solid #e0e0e0;">
          <td style="padding: 2px 10px; color: #000000; font-size: 12px; white-space: nowrap;"></td>
          <td style="padding: 2px 10px; color: #000000; font-size: 12px; white-space: nowrap;">${nightTariff?.name || 'Ночь'}</td>
          <td style="padding: 4px 10px; color: #000000; font-size: 12px; white-space: nowrap; text-align: right;">${nightTariff?.value || '-'}</td>
          <td style="padding: 2px 10px; color: #000000; font-size: 12px; white-space: nowrap; text-align: right;">${nightTariff?.consumption || '-'}</td>
          <td style="padding: 2px 10px 2px 40px; color: #000000; font-size: 12px; white-space: nowrap;">${source}</td>
        </tr>
      `;
     }

     // ДЕФОЛТНЫЙ ВАРИАНТ (ОДИН ТАРИФ) - Оставляем стандартные 14px и 10px
     return `
      <tr style="border-bottom: 1px solid #e0e0e0;">
        <td style="padding: 10px; color: #000000; font-size: 14px; white-space: nowrap;">${formattedDate}</td>
        <td style="padding: 10px; color: #000000; font-size: 14px; white-space: nowrap;">${record?.values?.[0]?.name || '-'}</td>
        <td style="padding: 10px; color: #000000; font-size: 14px; white-space: nowrap; text-align: right;">${record?.values?.[0]?.value || '-'}</td>
        <td style="padding: 10px; color: #000000; font-size: 14px; white-space: nowrap; text-align: right;">${record?.values?.[0]?.consumption || '-'}</td>
        <td style="padding: 10px 10px 10px 40px; color: #000000; font-size: 14px; white-space: nowrap;">${record?.values?.[0]?.sourceValue || '-'}</td>                
      </tr>
     `;
    })
    .join('');
  };

  const tableHeaderHtml = `
    <thead>
      <tr style="background-color: #f5f5f5; border-bottom: 2px solid #cccccc;">
        <th style="padding: 12px 10px; font-weight: bold; color: #555555; font-size: 14px; white-space: nowrap; width: 15%;">Дата показаний</th>
        <th style="padding: 12px 10px; font-weight: bold; color: #555555; font-size: 14px; white-space: nowrap; width: 25%;">Шкала</th>
        <th style="padding: 12px 10px; font-weight: bold; color: #555555; font-size: 14px; white-space: nowrap; text-align: right; width: 15%;">Показания</th>
        <th style="padding: 12px 10px; font-weight: bold; color: #555555; font-size: 14px; white-space: nowrap; text-align: right; width: 15%;">Расход</th>
        <th style="padding: 12px 10px 12px 40px; font-weight: bold; color: #555555; font-size: 14px; white-space: nowrap; width: 30%;">Источник приема показаний</th>                              
      </tr>
    </thead>
  `;

  const createPageImage = async (htmlContent: string) => {
   const element = document.createElement('div');
   element.style.position = 'absolute';
   element.style.left = '-9999px';
   element.style.top = '0';
   element.style.width = '1200px';
   element.style.padding = '30px 40px'; // Немного уменьшили верхний/нижний отступ контейнера
   element.style.backgroundColor = '#ffffff';
   element.style.fontFamily = 'Arial, sans-serif';
   element.style.color = '#282828';
   element.innerHTML = htmlContent;

   document.body.appendChild(element);

   const canvas = await html2canvas(element, {
    scale: 2,
    logging: false,
    backgroundColor: '#ffffff',
   });

   const imgData = canvas.toDataURL('image/jpeg', 1.0);
   const calculatedHeight = (canvas.height * imgWidth) / canvas.width;

   document.body.removeChild(element);
   return { imgData, calculatedHeight };
  };

  const pagesData: any[][] = [];
  let currentChunk: any[] = [];
  let isFirstPage = true;

  accruals.forEach((record: any) => {
   const currentLimit = isFirstPage
    ? ITEMS_PER_FIRST_PAGE
    : ITEMS_PER_NEXT_PAGES;

   if (currentChunk.length >= currentLimit) {
    pagesData.push(currentChunk);
    currentChunk = [record];
    isFirstPage = false;
   } else {
    currentChunk.push(record);
   }
  });

  if (currentChunk.length > 0) {
   pagesData.push(currentChunk);
  }

  try {
   if (pagesData.length > 0) {
    const firstPageHtml = `
        <h2 style="font-size: 22px; margin-bottom: 20px; color: #282828;">История показаний за период с ${moment(dateFrom).format('DD.MM.YYYY')} по ${moment(dateTo).format('DD.MM.YYYY')} </h2>
        <table style="width: 100%; border-collapse: collapse; text-align: left;">
          ${tableHeaderHtml}
          <tbody>${generateRowsHtml(pagesData[0])}</tbody>
        </table>
      `;

    const firstPage = await createPageImage(firstPageHtml);
    pdf.addImage(
     firstPage.imgData,
     'JPEG',
     15,
     15,
     imgWidth,
     firstPage.calculatedHeight,
    );
   }

   for (let i = 1; i < pagesData.length; i++) {
    pdf.addPage();

    const nextPageHtml = `
        <table style="width: 100%; border-collapse: collapse; text-align: left;">
          ${tableHeaderHtml}
          <tbody>${generateRowsHtml(pagesData[i])}</tbody>
        </table>
      `;

    const nextPage = await createPageImage(nextPageHtml);
    pdf.addImage(
     nextPage.imgData,
     'JPEG',
     15,
     15,
     imgWidth,
     nextPage.calculatedHeight,
    );
   }

   pdf.save(`Показания.pdf`);
  } catch (error) {
   console.error('Ошибка при генерации PDF:', error);
  }
 };

 const showData = () => {
  if (askueValue) {
   if (
    contractNumber &&
    meteringDevice &&
    typeDevice &&
    dateTo &&
    dateFrom &&
    accruals &&
    accruals.length > 0
   ) {
    return true;
   }
   return false;
  } else {
   if (
    contractNumber &&
    meteringDevice &&
    typeDevice &&
    accruals &&
    accruals.length > 0
   ) {
    return true;
   }
   return false;
  }
 };

 const showGraph = () => {
  if (!isElectricity) {
   return false;
  }

  if (askueValue) {
   if (
    contractNumber &&
    meteringDevice &&
    typeDevice &&
    dateTo &&
    dateFrom &&
    accruals &&
    accruals.length > 0
   ) {
    return true;
   }
   return false;
  } else {
   if (
    contractNumber &&
    meteringDevice &&
    typeDevice &&
    accruals &&
    accruals.length > 0
   ) {
    return true;
   }
   return false;
  }
 };

 return (
  <ContentWrapper>
   <SelectBlock>
    <SelectContract
     changeContract={changeContract}
     contracts={contracts}
     value={contractNumber}
    />
    {contractNumber !== null && contractNumber !== undefined ? (
     <SelectConnection
      changeConnection={changeConnection}
      connections={connections}
      value={meteringDevice}
     />
    ) : null}
    {meteringDevice !== null && meteringDevice !== undefined ? (
     <SelectTypeDevice
      showSearch
      optionFilterProp="children"
      placeholder="Выберите ПУ"
      value={typeDevice}
      onChange={(value) => {
       changeTypeDevice(value);
       onFinish(value);
      }}
      loading={isLoading}
     >
      {meterings?.map((item) => (
       <Select.Option key={item.meteringDeviceId} value={item.meteringDeviceId}>
        {item.meteringDeviceNumber}
       </Select.Option>
      ))}
     </SelectTypeDevice>
    ) : null}

    {meteringDevice !== null &&
    meteringDevice !== undefined &&
    askueValue &&
    accruals &&
    accruals?.length > 0 ? (
     <RangePicker
      allowClear
      format="DD.MM.YYYY"
      style={{ width: '400px', marginRight: '10px' }}
      onChange={(value) => {
       handleDateRangeValues(value);
       onFinishAskue(value, typeDevice);
      }}
      defaultValue={defaultDateRange}
     />
    ) : null}

    {meteringDevice !== null &&
    meteringDevice !== undefined &&
    askueValue &&
    accruals &&
    accruals?.length > 0 ? (
     <React.Fragment>
      <SubmitButton
       disabled={!dateFrom || !dateTo || !defaultDateRange}
       style={{
        background: 'linear-gradient(#fff, #fff) padding-box',
        width: '200px',
       }}
       onClick={exportData}
      >
       Экспорт в Excel
      </SubmitButton>

      <SubmitButton
       disabled={!dateFrom || !dateTo || !defaultDateRange}
       style={{
        background: 'linear-gradient(#fff, #fff) padding-box',
        width: '200px',
       }}
       onClick={exportToPdf}
      >
       Скачать очет
      </SubmitButton>
     </React.Fragment>
    ) : null}
   </SelectBlock>

   {accruals && accruals.length > 0 ? (
    <div
     style={{
      display: 'flex',
      flexDirection: 'column',
      height: '700px',
     }}
    >
     {showGraph() ? (
      <div
       style={{
        height: '350px',
        width: '100%',
        position: 'sticky',
        top: 0,
        alignSelf: 'flex-start',
        backgroundColor: 'white',
       }}
      >
       <ExpenseChart months={meterData?.months} values={meterData?.values} />
      </div>
     ) : (
      ''
     )}

     <div style={{ overflow: 'auto' }}>
      {isLoading ? (
       <Spinner size="large" />
      ) : showData() ? (
       <MeteringHistoryData data={accruals} />
      ) : null}
     </div>
    </div>
   ) : (
    ''
   )}
  </ContentWrapper>
 );
}

function useAccruals() {
 const queryClient = useQueryClient();
 const contracts = queryClient.getQueryData<Models.Contract[]>('contracts');
 const [contractNumber, setContractId] = useState<number>(null);
 const [contractData, setContractData] = useState(null);
 const [isElectricity, setIsElectricity] = useState(false);
 const [meteringDevice, setMeteringDevice] = useState<number>(null);
 const [typeDevice, setTypeDevice] = useState<string>(null);
 const [dateFrom, setDateFrom] = useState<string>(null);
 const [dateTo, setDateTo] = useState<string>(null);
 const [defaultDateRange, setDefaultDateRange] = useState(null);

 const changeContract = (value) => {
  setContractId(value);

  setDateFrom(null);
  setDateTo(null);

  if (contracts && contracts.length > 0) {
   const selectedContract = contracts.filter((x: any) => x.id === value);

   if (selectedContract && selectedContract.length > 0) {
    setContractData(selectedContract[0]);

    if (
     selectedContract[0].resources.toLowerCase().indexOf('электроэнергия') !==
     -1
    ) {
     setIsElectricity(true);
    } else {
     setIsElectricity(false);
    }
   }
  }

  setTypeDevice(null);
  setMeteringDevice(null);
  onFinish(null);
  setDefaultDateRange(null);

  if (setContractId) {
   setMeteringDevice(null);
   setTypeDevice(null);
   setDefaultDateRange(null);
  }
 };

 const changeConnection = (value) => {
  setMeteringDevice(value);

  setTypeDevice(null);
  onFinish(null);
  setDefaultDateRange(null);

  setDateFrom(null);
  setDateTo(null);

  if (setMeteringDevice) {
   setTypeDevice(null);
   setDefaultDateRange(null);
  }
 };

 const changeTypeDevice = (value) => {
  setTypeDevice(value);

  setDateFrom(null);
  setDateTo(null);

  if (!value) {
   setTypeDevice(null);
   onFinish(null);
   setDefaultDateRange(null);
  }
 };

 const handleDateRangeValues = (e: any) => {
  if (e && e.length > 1) {
   const dateFrom = e[0]._d;
   const dateTo = e[1]._d;

   setDefaultDateRange(e);

   if (dateFrom) {
    setDateFrom(dateFrom);
   } else {
    setDateFrom(null);
   }

   if (dateTo) {
    setDateTo(dateTo);
   } else {
    setDateTo(null);
   }
  } else {
   setDateFrom(null);
   setDateTo(null);
   setDefaultDateRange(null);
  }
 };

 const { data: connections } = useQuery<Models.Connection[]>(
  ['connections', contractNumber],
  () => srv.getConnections(contractNumber),
 );

 const { data: meterings } = useQuery<Models.MeteringDevices[]>(
  ['meterings', meteringDevice],
  () => srv.getMeteringDeviceUnique(meteringDevice),
 );

 let {
  data: accruals,
  mutate: save,
  isLoading,
 } = useMutation(srv.getMeteringAccruals);

 const onFinish = useCallback(
  (typeDevice) => {
   if (contractNumber && typeDevice) {
    save({
     contractId: contractNumber,
     meteringDeviceAisId: typeDevice,
     dateFrom: null,
     dateTo: null,
    });
   }
  },
  [save, contractNumber],
 );

 const onFinishAskue = useCallback(
  (dates, typeDevice) => {
   let dateFrom = null;
   let dateTo = null;

   if (dates && dates.length > 1) {
    dateFrom = moment(dates[0]._d).format('YYYY-MM-DDTHH:mm:ss');
    dateTo = moment(dates[1]._d).format('YYYY-MM-DDTHH:mm:ss');
   }

   save({
    contractId: contractNumber,
    meteringDeviceAisId: typeDevice,
    dateFrom: dateFrom,
    dateTo: dateTo,
   });
  },
  [save, contractNumber],
 );

 return {
  changeContract,
  changeConnection,
  changeTypeDevice,
  handleDateRangeValues,
  dateFrom,
  dateTo,
  defaultDateRange,
  typeDevice,
  contractNumber,
  meteringDevice,
  onFinish,
  onFinishAskue,
  connections,
  meterings,
  contracts,
  isLoading,
  accruals: accruals?.history,
  accrualsAskue: accruals?.historyAskue,
  contractData,
  isElectricity,
 };
}
